module.exports = __webpack_public_path__ + "img/B5-canada.b5706779.png";